import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCodeRoute: InvariantJiraRoute = {
	name: 'software-code',
	path: '/jira/software/projects/:projectKey/code',
};
